import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {Edge} from "../types/Edge";

export const useGetEdges = (dealerID: number, prodQteGrpID: number, pricingDate: Date, zipCode: string) => {
    const {data, isLoading} = useQuery({
        queryKey: ['ee-pro-edges', prodQteGrpID, dealerID, zipCode],
        queryFn: async () => await apiClient.get('ee-pro/edges?dealerID=' + dealerID + '&prodQteGrpID=' + prodQteGrpID + '&pricingDate=' + pricingDate.toISOString() + '&zipCode=' + zipCode) as Edge[],
        enabled: prodQteGrpID > 0,
        staleTime: 5 * 60 * 1000
    });

    return {
        data: data || [],
        isLoading: isLoading
    };
};
